import { render, staticRenderFns } from "./PortalProofsPage.vue?vue&type=template&id=d62f7166&scoped=true&"
import script from "./PortalProofsPage.vue?vue&type=script&lang=js&"
export * from "./PortalProofsPage.vue?vue&type=script&lang=js&"
import style0 from "./PortalProofsPage.vue?vue&type=style&index=0&id=d62f7166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62f7166",
  null
  
)

export default component.exports